<template>
  <div class="hello">
    <header class="codice-header">
      <h1 class="codice-title">Nepohualtzintzin</h1>
      <p class="codice-subtitle">ábaco mesoamericano</p>
      <!-- Step-fret glyph divider -->
      <svg class="codice-glyph" viewBox="0 0 120 14" aria-hidden="true">
        <path d="M2 11 L18 11 L18 5 L26 5 L26 11 L34 11"
              fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"/>
        <circle cx="46" cy="7" r="1.6" fill="currentColor"/>
        <path d="M54 7 L60 1 L66 7 L60 13 Z" fill="currentColor"/>
        <circle cx="74" cy="7" r="1.6" fill="currentColor"/>
        <path d="M86 11 L94 11 L94 5 L102 5 L102 11 L118 11"
              fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"/>
      </svg>
    </header>

    <abacus></abacus>

    <div class="codice-readings">
      <div class="reading reading--vigesimal">
        <span class="reading__label">Vigesimal</span>
        <span class="reading__value">{{ value | toBaseTwenty }}</span>
        <span class="reading__caption">base veinte</span>
      </div>

      <div class="codice-readings__divider" aria-hidden="true">
        <svg viewBox="0 0 8 80" preserveAspectRatio="none">
          <line x1="4" y1="0" x2="4" y2="80" stroke="currentColor" stroke-width="0.6" stroke-dasharray="2 4"/>
          <circle cx="4" cy="40" r="2" fill="currentColor"/>
        </svg>
      </div>

      <div class="reading reading--decimal">
        <span class="reading__label">Decimal</span>
        <input class="reading__input"
               type="text"
               :value="value"
               @input="setNumber($event.target.value)">
        <span class="reading__caption">base diez</span>
      </div>
    </div>

    <challenge-mode></challenge-mode>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Abacus from './Abacus'
import ChallengeMode from './ChallengeMode'

export default {
  name: 'hello',
  components: {
    Abacus,
    ChallengeMode
  },
  computed: mapState({
    value (state) {
      return state.abacus.value
    }
  }),
  filters: {
    toBaseTwenty (n) {
      return n.toString(20).toUpperCase()
    }
  },
  methods: {
    setNumber (number) {
      this.setAbacusNumber({
        number: number
      })
    },
    ...mapMutations([
      'setAbacusNumber'
    ])
  }
}
</script>

<style scoped>
.hello {
  text-align: center;
}

/* ---------- Header ---------- */
.codice-header {
  margin: 0 auto 2.5rem;
  padding: 0 1rem;
}

.codice-title {
  font-family: 'Cinzel Decorative', 'Cinzel', serif;
  font-weight: 700;
  font-size: clamp(2.4rem, 5vw, 3.8rem);
  letter-spacing: 0.08em;
  line-height: 1.05;
  color: var(--obsidiana);
  margin: 0;
}

.codice-subtitle {
  font-family: 'Crimson Pro', Georgia, serif;
  font-style: italic;
  font-size: 1.2rem;
  color: var(--cinabrio);
  margin: 0.4rem 0 0;
  letter-spacing: 0.02em;
}

.codice-glyph {
  display: block;
  width: 140px;
  height: 16px;
  margin: 0.9rem auto 0;
  color: var(--ink-trace);
  opacity: 0.75;
}

/* ---------- Readings (decimal / vigesimal) ---------- */
.codice-readings {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 1.5rem;
  max-width: 560px;
  margin: 2rem auto 2.5rem;
  padding: 0 1rem;
}

.reading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
}

.reading__label {
  font-family: 'Cinzel', 'Cinzel Decorative', serif;
  font-variant: small-caps;
  font-size: 0.85rem;
  letter-spacing: 0.12em;
  color: var(--obsidiana-soft);
}

.reading__value,
.reading__input {
  font-family: 'DM Mono', 'Menlo', monospace;
  font-size: clamp(1.7rem, 3.6vw, 2.2rem);
  color: var(--obsidiana);
  line-height: 1.1;
  font-weight: 500;
}

.reading__caption {
  font-family: 'Crimson Pro', Georgia, serif;
  font-style: italic;
  font-size: 0.8rem;
  color: var(--ink-trace);
  letter-spacing: 0.01em;
}

.reading__input {
  background: transparent;
  border: none;
  outline: none;
  text-align: center;
  width: 100%;
  max-width: 180px;
  padding: 2px 0 4px;
  border-bottom: 1px solid transparent;
  transition: border-color 220ms ease;
}

.reading__input:hover {
  border-bottom-color: var(--ink-trace);
}

.reading__input:focus {
  border-bottom-color: var(--cinabrio);
  border-bottom-width: 2px;
  padding-bottom: 3px;
}

/* ---------- Divider between readings ---------- */
.codice-readings__divider {
  width: 10px;
  height: 80px;
  color: var(--ink-trace);
  opacity: 0.55;
  display: flex;
  align-items: center;
  justify-content: center;
}

.codice-readings__divider svg {
  width: 100%;
  height: 100%;
}

@media (max-width: 480px) {
  .codice-readings {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }
  .codice-readings__divider {
    width: 80px;
    height: 10px;
    transform: rotate(90deg);
  }
}
</style>



// WEBPACK FOOTER //
// Hello.vue?60f7c084